function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Animate the scrolling for hash links
 * @TODO checkout using popstate for these to keep navigation hash
 */
var SmoothScroller = /*#__PURE__*/function () {
  /**
   * Create a SmoothScroller
   *
   * @param  {integer} offset - pixel distance to adjust scroll
   * @param  {string}  ignore - array of selectors for hash links to ignore smooth scrolling
   * @return {void}
   */
  function SmoothScroller() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, SmoothScroller);
    this.offset = offset;
    this.ignore = ignore;
    this.ignore.push('.smooth--ignore', '.cmplz-cookiebanner a, .cmplz-link');
    this.bindEventHandlers();
  }

  /**
   * Register handlers for all "#" links
   *
   * Delegated to document so the selector is evaluated at click time.
   * Links that are injected late or whose href changes after init (e.g. the
   * Complianz cookie banner renders href="#" placeholders, then swaps in the
   * real policy URLs) are matched against their *current* href, not the one
   * they had when the page loaded.
   *
   * @return {void}
   */
  return _createClass(SmoothScroller, [{
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      var self = this;
      jQuery(document).off('click.smooth').on('click.smooth', 'a[href^="#"]', function (e) {
        // .not() doesn't work with delegated handlers — check the ignore list here
        if (jQuery(this).is(self.ignore.join(','))) return;
        return self.scrollTo(this.hash);
      });
    }

    /**
     * Animate the page to scroll to a target
     *
     * @param {string} target - `#ID` for target element to scroll to
     * @return void
     */
  }, {
    key: "scrollTo",
    value: function scrollTo(target) {
      var $el = jQuery(target);
      var self = this;
      if ($el.length === 0) return false;
      jQuery("body,html").stop().animate({
        scrollTop: $el.offset().top - self.offset
      }, 300);
    }

    /**
     * Scroll to a hash on page load if one exists
     *
     * @TODO check if should be ignored
     * @return void
     */
  }, {
    key: "scrollOnLoad",
    value: function scrollOnLoad() {
      if (!window.location.hash) return false;
      this.scrollTo(window.location.hash);
    }
  }]);
}();
export { SmoothScroller as default };